import Repository from '../Repository';

const resource = '/balance';

export default {
	show(id) {
		return Repository.get(`${resource}/${id}`);
	},
	transactions(id, params) {
		return Repository.get(`${resource}/${id}/transactions`, { params: params });
	}
}